module.exports = __webpack_public_path__ + "static/media/baby.0f16fea0.png";